// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* src/components/Header.css */
.header {
    background-color: var(--white);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .logo h1 {
    color: var(--primary-color);
    font-size: 24px;
    font-weight: 700;
    margin: 0;
  }
  
  .navigation ul {
    display: flex;
    list-style: none;
    gap: 24px;
  }
  
  .navigation a {
    color: var(--text-color);
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .navigation a:hover {
    color: var(--primary-color);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/Header.css"],"names":[],"mappings":";AACA,8BAA8B;AAC9B;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B","sourcesContent":["\n/* src/components/Header.css */\n.header {\n    background-color: var(--white);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    padding: 16px 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .logo h1 {\n    color: var(--primary-color);\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0;\n  }\n  \n  .navigation ul {\n    display: flex;\n    list-style: none;\n    gap: 24px;\n  }\n  \n  .navigation a {\n    color: var(--text-color);\n    font-weight: 500;\n    font-size: 16px;\n    text-decoration: none;\n    transition: color 0.3s ease;\n  }\n  \n  .navigation a:hover {\n    color: var(--primary-color);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
